import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Dialog,
  TextV2,
  CheckboxV2,
} from '@insights-ltd/design-library/components';
import { Trans, useTranslation } from 'react-i18next';
import { styled } from '@mui/material';

export type EditContributorsDialogConfirmProps = {
  open: boolean;
  onCancel: () => void;
  onHandleRemoveProfileContributors: () => void;
  isPending: boolean;
};

const StyledDiv = styled('div')({
  display: 'flex',
  gap: '1rem',
});

const EditContributorsDialogConfirm = ({
  open,
  onCancel,
  onHandleRemoveProfileContributors,
  isPending,
}: EditContributorsDialogConfirmProps) => {
  const { t } = useTranslation();
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);

  const resetStates = () => {
    setConfirmDelete(false);
  };

  useEffect(() => {
    if (open === false) {
      resetStates();
    }
  }, [open]);

  return (
    <Dialog
      onSubmit={onHandleRemoveProfileContributors}
      onClose={() => {
        onCancel();
        resetStates();
      }}
      open={open}
      content={
        <Box>
          <Trans
            i18nKey="ui.event-management.learners.profile.dfc.edite-contributors.modal-confirm.content-1"
            components={{
              bold: <TextV2 component="span" variant="bodyBold" />,
            }}
          />
          <br /> <br />
          <div>
            {t(
              'ui.event-management.learners.profile.dfc.edite-contributors.modal-confirm.content-2',
            )}
          </div>
          <br />
          <StyledDiv>
            <CheckboxV2 checked={confirmDelete} onChange={setConfirmDelete} />
            <TextV2 component="p" variant="bodyBold" color="error">
              {t(
                'ui.event-management.learners.profile.dfc.edite-contributors.modal-confirm.checkbox-content',
              )}
            </TextV2>
          </StyledDiv>
        </Box>
      }
      primaryButtonColour="error"
      primaryButtonText={t(
        'ui.event-management.learners.profile.dfc.edite-contributors.modal-confirm.button.confirm',
      )}
      disablePrimaryButton={!confirmDelete}
      secondaryButtonText={t(
        'ui.event-management.learners.profile.dfc.edite-contributors.modal-confirm.button.cancel',
      )}
      title={t(
        'ui.event-management.learners.profile.dfc.edite-contributors.modal-confirm.title',
      )}
      isLoading={isPending}
    />
  );
};

export default EditContributorsDialogConfirm;
